import { render, staticRenderFns } from "./VEstimatesTotal.vue?vue&type=template&id=252f7162&"
import script from "./VEstimatesTotal.vue?vue&type=script&lang=ts&"
export * from "./VEstimatesTotal.vue?vue&type=script&lang=ts&"
import style0 from "./VEstimatesTotal.vue?vue&type=style&index=0&id=252f7162&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports